export default __webpack_public_path__ + "static/media/Frame 3.3fd12dec.svg";